module.exports = __webpack_public_path__ + "img/logo.ba5957f6.png";